import { AxiosPromise } from 'axios';
import { http } from 'services';

export interface CoinWallet {
  balance: number;
  reserved: number;
}

export type CoinLedgerType = 'credit' | 'debit' | 'reserve' | 'release' | 'reversal';
export type CoinLedgerSource =
  | 'welcome'
  | 'referral'
  | 'promocode'
  | 'checkout'
  | 'topup'
  | 'refund'
  | 'admin';

export interface CoinLedgerEntry {
  id: string;
  type: CoinLedgerType;
  amount: number;
  balanceAfter: number;
  source: CoinLedgerSource;
  note?: string;
  createdAt?: string;
}

// Active-org coin wallet (balance + reserved).
export const GetWallet = (): AxiosPromise<CoinWallet> => http.request.get('/api/coins/wallet');

// Active-org coin ledger, most recent first.
export const GetLedger = (limit = 50): AxiosPromise<CoinLedgerEntry[]> =>
  http.request.get('/api/coins/ledger', { params: { limit } });

// Redeem a coin-grant promocode for the active org.
export const RedeemPromocode = (
  code: string,
  planKey?: string,
): AxiosPromise<{ coinsGranted: number }> =>
  http.request.post('/api/promocodes/redeem', { code, planKey });
